import {
  Component,
  EventEmitter,
  Input,
  Output,
  WritableSignal,
  signal,
} from "@angular/core";

import { FeedIssueType, FeedReport } from "@core/api-models/feeds.models";

@Component({
  selector: "ngx-feed-status",
  templateUrl: "./feed-status.component.html",
  standalone: false,
})
export class FeedStatusComponent {
  @Output() close = new EventEmitter<any>();

  errors: WritableSignal<FeedIssueType[]> = signal([]);
  warnings: WritableSignal<FeedIssueType[]> = signal([]);

  @Input() set report(to: FeedReport) {
    this.errors.update(() => to.errors ?? []);
    this.warnings.update(() => to.warnings ?? []);
  }
}
